package br.com.htms.inspeccaocampo.data

/**
 * Catálogo de obras (form dropdown). Seed embutido = fallback se a API falhar.
 * Lista canônica no servidor (D1); admin ativa/desativa e adiciona itens.
 */
data class ObraItem(
    val id: String,
    val nome: String,
    val ativo: Boolean = true,
    val sortOrder: Int = 0
)

object ObraCatalog {
    /** Nomes iniciais (todos ativos). Ordem = sort_order no seed. */
    val SEED_NOMES: List<String> = listOf(
        "MATRIZ ADM-ENERGIA",
        "ALMOX-ENERGIA",
        "ALOCAÇÃO COMPARTILHADA",
        "COMERCIAL ENERGIA",
        "CONSÓRCIO TAPA",
        "LT BERNECK",
        "SE AREIA - AXIA - ENERGIA",
        "SE CURITIBA - AXIA - ENERGIA",
        "LDAT 138 kV BARBOSA FERRAZ - IVAIPORÃ - COPEL DIS.",
        "TUCUMANN/ATOM - RELOCAÇÃO 109 - COPEL DIS.",
        "Secc da LDAT 138kV Porto / Paranaguá na SE APPA e SE 138kV APPA",
        "SE JOINVILLE SUL - NEO",
        "SE CAMPOS NOVOS 525 kV - ENERGIA",
        "SE SALTO SANTIAGO - ENERGIA",
        "SE GUARAPUAVA (SE GVA) - COPEL DIS",
        "SE CURITIBA - AMP. N",
        "LDAT 138kV ARE.PAS/ARE.FOS",
        "SE CASCAVEL NORTE",
        "ATOM - SECCIONAMENTO PARANAGUÁ na SE APPA",
        "AXIA - Subestação Passo Fundo - SE PFU",
        "AXIA - Subestação Xanxerê - SE XAN",
        "COPEL - Reconstrução Emergencial LDAT Cascavel",
        "PROJ TRANS RQL (FD)",
        "COPEL TRANSM",
        "PROJ TRANS RQL (HTMS)",
        "FD - SE CAMPOS NOVOS - CLIENTE",
        "FD - SE SALTO SANTIAGO - CLIENTE",
        "FD - SE CASCAVEL NORTE - CLIENTE",
        "FD - CURITIBA - AMP. N - CLIENTE",
        "FD - CLIENTE SE PASSO FUNDO / XANXERE"
    )

    fun seedAtivas(): List<ObraItem> =
        SEED_NOMES.mapIndexed { i, nome ->
            ObraItem(id = "seed_$i", nome = nome, ativo = true, sortOrder = i)
        }
}
